import { createContext } from "react"

import { popUpMessage } from "./RecipeCreation"

interface IPopUpContext {
  content: popUpMessage | null
  setContent: (content: popUpMessage) => void
}

export const PopUpContext = createContext<IPopUpContext | null>(null)
